<template>
  <div>
    <spinnerProcessando cssClass="ml-2" :status="flagsDeControle.carregandoDados.status" :mensagem="flagsDeControle.carregandoDados.mensagem"/>
    <ListagemFaturas
        v-show="!mostrarDetalhe"
        :faturas="listaFaturas"
        :colunas="fields"
        :flagsDeControle="flagsDeControle"
        :obterFaturas="obterListaFaturas"
        :componentePaginacao="componentePaginacao">
        <template #empty>
          <em>Nenhum registro encontrado.</em>
        </template>
        <template #cell(data_vencimento)="row">
          {{$date(row.item.data_vencimento).format('DD/MM/YYYY')}}
        </template>
        <template #cell(data_emissao)="row">
          {{$date(row.item.data_emissao).format('DD/MM/YYYY')}}
        </template>
        <template #cell(valor_total)="row">
          {{ formatarValorMonetario(row.item.valor_total) }}
        </template>
        <template #descricao="{ row }">
          <a href="#" class="linkr" @click.prevent="selecionarFatura(row)">
                {{ obterDescricaoFatura(row) }}
          </a>
        </template>
        <template #cell(status)="row">
          <span :class="{'statusPago': row.item.status === 1,
                          'statusPendente': row.item.status === 2 || row.item.status === 4,
                          'statusAberto': row.item.status === 3}">
            {{ obterDescricaoStatusFatura(row.item.status) }}
          </span>
        </template>
    </ListagemFaturas>
    <DetalheFatura
      v-if="mostrarDetalhe && apresentarDetalheFatura"
      :flagsDeControle="flagsDeControle"
      :detalheFatura="detalheFatura"
      :cupomSelecionado="cupomSelecionado"
      :itensDaFatura="itensDaFatura"
      :apenasLeitura="true"
      >
      <template #acoes>
        <div class="row btn-group-justified justify-content-end" role="group">
          <div class="row btn-group-justified justify-content-end" role="group">
            <button class="btn btn-md btn-light border-secondary" @click="voltarParaListagem()" :disabled="desabilitarCampos">Voltar</button>
          </div>
        </div>
      </template>
    </DetalheFatura>
  </div>
</template>

<script>
import Faturas from './js/faturas'
export default Faturas
</script>
